<template>
    <div class="box">
        <div class="about wow animate__animated animate__fadeInUp">
            <div class="user_bor about-item">
                <div class="num">{{ info_data.no_pay_count }}</div>
                <div class="text">— {{$t('m.userhome_01')}} —</div>
            </div>
            <div class="user_bor about-item">
                <div class="num">{{ info_data.pay_amount }}</div>
                <div class="text">— {{$t('m.userhome_02')}} —</div>
            </div>
        </div>
        <div class="user_bor wow animate__animated animate__fadeInUp">
            <div class="user_box">
                <div class="user_box_left">
                    {{$t('m.userhome_03')}}
                </div>
                <div class="user_box_right"></div>
            </div>
            <div class="user_bor_text">
				<div v-html="service_phone"></div>
            </div>
        </div>
        <div class="user_bor wow animate__animated animate__fadeInUp">
            <div class="user_box">
                <div class="user_box_left">
                    {{$t('m.userhome_04')}}
                </div>
                <div class="user_box_right">
					
				</div>
            </div>
            <div class="Echarts">
                <div id="main" style="width: 100%;height:18rem;"></div>
            </div>
        </div>
        <div class="user_bor wow animate__animated animate__fadeInUp">
            <div class="user_box">
                <div class="user_box_left">
                    {{$t('m.userhome_05')}}
                </div>
                <div class="user_box_right">
				
                </div>
            </div>
            <div class="Echarts">
                <div id="main1" style="width: 100%;height:18rem;"></div>
            </div>
        </div>
    </div>
</template>
<script>
import Cookies from 'js-cookie'
import * as echarts from 'echarts';
import encryption from '@/utils/encryption.js'
export default {
    data() {
        return {
            service_phone: [],
            info_data: {},
            month_num_arr: [],
            month_money_arr:[],
			lang:0,
        }
    },
    mounted() {
        this.getweb_info()
        this.getData()
		
    },
	created(){
		let lang = Cookies.get('lang')
		this.lang = lang
	},
    methods: {
        getweb_info() {
            this.$api.web_info().then((res) => {
                if (res.data.code == 1) {
					// 将\r\n转换成<br>
					var html = res.data.data.service_phone
					var reg = new RegExp("\r\n", "g");
                    this.service_phone=html.replaceAll(reg, '<br/>');
                }
            })
        },
        getData() {
			let that = this
            let param = {
                user_id: JSON.parse(localStorage.getItem('user_data')).id
            }
            let sing = encryption.getSing(param)
            this.$api.user_home(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.info_data = res.data.data
                    let data1 = res.data.data.month_num_arr
                    let data2 = res.data.data.month_money_arr
					let lang = this.lang
					if(lang==2){
						// 中文
						this.month_num_arr.push(
						    ['1月', data1['1月']],
						    ['2月', data1['2月']],
						    ['3月', data1['3月']],
						    ['4月', data1['4月']],
						    ['5月', data1['5月']],
						    ['6月', data1['6月']],
						    ['7月', data1['7月']],
						    ['8月', data1['8月']],
						    ['9月', data1['9月']],
						    ['10月', data1['10月']],
						    ['11月', data1['11月']],
						    ['12月', data1['12月']])
						this.month_money_arr.push(
						    ['1月', data2['1月']],
						    ['2月', data2['2月']],
						    ['3月', data2['3月']],
						    ['4月', data2['4月']],
						    ['5月', data2['5月']],
						    ['6月', data2['6月']],
						    ['7月', data2['7月']],
						    ['8月', data2['8月']],
						    ['9月', data2['9月']],
						    ['10月', data2['10月']],
						    ['11月', data2['11月']],
						    ['12月', data2['12月']])
					}else if(lang==1){
						// 英文
						this.month_num_arr.push(
						    ['January', data1['1月']],
						    ['February', data1['2月']],
						    ['March', data1['3月']],
						    ['April', data1['4月']],
						    ['May', data1['5月']],
						    ['June', data1['6月']],
						    ['July', data1['7月']],
						    ['August', data1['8月']],
						    ['September', data1['9月']],
						    ['October', data1['10月']],
						    ['November', data1['11月']],
						    ['December', data1['12月']])
						this.month_money_arr.push(
							['January', data1['1月']],
							['February', data1['2月']],
							['March', data1['3月']],
							['April', data1['4月']],
							['May', data1['5月']],
							['June', data1['6月']],
							['July', data1['7月']],
							['August', data1['8月']],
							['September', data1['9月']],
							['October', data1['10月']],
							['November', data1['11月']],
							['December', data1['12月']])
					}
					
					

						
						
						
                    this.myEcharts();
                    this.myEcharts1();
                }
            })
        },
        myEcharts() {
            var chartDom = document.getElementById('main');
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                xAxis: {
                    type: 'category',
                    boundaryGap: false,

                },
                yAxis: {

                    type: 'value',
                    boundaryGap: [0, '30%']
                },
				tooltip:{ // 鼠标悬浮提示框显示 X和Y 轴数据
					 trigger: 'axis',
					 backgroundColor: 'rgba(32, 33, 36,.7)',
					 borderColor: 'rgba(32, 33, 36,0.20)',
					 borderWidth: 1,
					 textStyle: { // 文字提示样式
					   color: '#fff',
					   fontSize: '12'
					 },
					 axisPointer: { // 坐标轴虚线
					   type: 'cross',
					   label: {
						   backgroundColor: '#6a7985'
						},
					},
					formatter(params){
						// console.log(params.data)
						let lang = Cookies.get('lang')
						if(lang==2){
							return params[0].data[0]+"："+params[0].data[1]+'单';
						}else{
							return params[0].data[0]+"："+params[0].data[1]+' Order';
						}
						
						
					},
				},
                visualMap: {
                    type: 'piecewise',
                    show: false,
                    dimension: 0,
                    seriesIndex: 0,
                    pieces: [
                        {
                            gt: 0,
                            lt: 12,
                            color: 'rgba(250, 224, 221)'
                        },
                    ]
                },
                series: [
                    {
                        type: 'line',
                        smooth: 0.6,
                        symbol: 'none',
                        lineStyle: {
                            color: '#ef5843',
                            width: 5
                        },
                        markLine: {
                            symbol: ['none', 'none'],
                            label: { show: false },

                        },
                        areaStyle: {},
                        data: this.month_num_arr
                    }
                ]
            };
            option && myChart.setOption(option);
        },
        myEcharts1() {
            var chartDom = document.getElementById('main1');
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                xAxis: {
                    type: 'category',
                    boundaryGap: false,

                },
				tooltip:{ // 鼠标悬浮提示框显示 X和Y 轴数据
					 trigger: 'axis',
					 backgroundColor: 'rgba(32, 33, 36,.7)',
					 borderColor: 'rgba(32, 33, 36,0.20)',
					 borderWidth: 1,
					 textStyle: { // 文字提示样式
					   color: '#fff',
					   fontSize: '12'
					 },
					 axisPointer: { // 坐标轴虚线
					   type: 'cross',
					   label: {
						   backgroundColor: '#6a7985'
						},
					},
					formatter(params){
						// console.log(params)
						// return params[0].data[0]+"："+params[0].data[1]+'单';
						
						return params[0].data[0]+"：$"+params[0].data[1];
					},
				},
                yAxis: {
                    type: 'value',
                    boundaryGap: [0, '30%']
                },
                visualMap: {
                    type: 'piecewise',
                    show: false,
                    dimension: 0,
                    seriesIndex: 0,
                    pieces: [
                        {
                            gt: 0,
                            lt: 12,
                            color: 'rgba(250, 224, 221)'
                        },

                    ]
                },
                series: [
                    {
                        type: 'line',
                        smooth: 0.6,
                        symbol: 'none',
                        lineStyle: {
                            color: '#ef5843',
                            width: 5
                        },
                        markLine: {
                            symbol: ['none', 'none'],
                            label: { show: false },

                        },
                        areaStyle: {},
                        data: this.month_money_arr
                    }
                ]
            };
            option && myChart.setOption(option);
        }
    },
}
</script>
<style lang="scss" scoped>
// .box{
//     min-width: 800px;
// }
.user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;
    padding-left: 20px;
    .user_box_left {
        padding-left: 25px;
    }

}

.user_bor_text {
    display: flex;
    align-items: center;
    
    padding: 0 50px;
    margin-top: 20px;
    flex-wrap: wrap;
    font-size: 15px;

    .phone {
        margin-left: 40px;
        font-weight: bold;
        
    }
   
}
.user_bor_text>:first-child{
    margin-left: 0 !important;
}

.Echarts {
    padding: 0 10px;

    width: 100%;
}

.about {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .about-item {
        width: 49%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 35px 0 !important;
        flex-direction: column;

        .num {
            font-weight: bold;
            color: #ef5843;
            font-size: 30px;
            width: 100%;
            text-align: center;
            border-left: 5px solid #ef5843 !important;
            height: 26px;

        }

        .text {
            font-weight: bold;
            font-size: 15px;
            margin-top: 40px;

            text-align: center;
        }
    }
}

// 宽度小于1200px
@media screen and (max-width: 1200px){
	.user_box{
		padding: 0!important;
		.user_box_left{
			padding-left: 1rem;
			font-size: 0.7rem!important;
		}
	}
	.about-item{
		.text{
			font-size: 0.7rem!important;
		}
	}
	.user_bor_text{
		padding: 0 1rem;
		transform: translateX(5px);
		font-size: 0.7rem!important;
	}
	.Echarts{
		width: 100%;
	}
}



</style>